import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { formatDate } from "features/shared/helpers/Formatters";
import { useTranslation } from "react-i18next";
import { ContractProcessDTO } from "../dtos/ContractProcessDTO";
import { getCommodityIcon } from "features/contracts/helpers/commodityDetailHelper";
import ContractLink from "features/invoices/components/ContractLink";
import EntityLinkDTO from "features/invoices/dtos/EntityLinkDTO";
import { Entity } from "features/shared/enums/entity";

type ContractProcessItem = NonNullable<ContractProcessDTO["result"]>[number];

interface Props {
  contractProcess: ContractProcessItem;
}

const ContractProcessInfoCard = ({ contractProcess }: Props) => {
  const t = useTranslation("contractProcess\\contractProcess").t;
  const { contractId, contractNumber } = contractProcess;

  const renderContractNumberLink = (id?: string | null, number?: string | null) => {
    if (!id || !number) return "-";

    const entityLink: EntityLinkDTO = {
      entity: Entity.Contract,
      entityId: id,
      name: number,
    } as EntityLinkDTO;

    return (
      <ContractLink
        entityLink={entityLink}
        smallText={false}
        className="text-break"
      />
    );
  };

  return (
    <PageCard title={t("basicInfo.title")}>
      <div className="d-flex flex-nowrap align-items-center">
        <div className="flex-grow-1">
          <div className="row no-gutters">
            <div className="col-12 col-md-6 col-lg-3">
              <InfoItem title={t("basicInfo.contractNumber")} value={renderContractNumberLink(contractId, contractNumber)} icon={getCommodityIcon(contractProcess.commodityDetail!)} />
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <InfoItem title={t("basicInfo.processName")} value={contractProcess.processName || "-"} icon="tag" />
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <InfoItem title={t("basicInfo.processState")} value={contractProcess.processState || "-"} icon="hourglass-start" />
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <InfoItem title={t("basicInfo.effectiveDate")} value={formatDate(contractProcess.effectiveDate || "") || "-"} icon="calendar-check" />
            </div>
          </div>
        </div>
      </div>
    </PageCard>
  );
};

export default ContractProcessInfoCard;
